import React, { Component } from 'react';
import { Row, Col, Input } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class IndividualResponsibilities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeData: [],
            clientData: [],
            sheetData: [],
            selector: this.props.selector != null ? this.props.selector : '',
            selectedEmployee: this.props.selector != null ? parseInt(this.props.selector) : '',
        };
    }

    componentDidMount() {
        this.props.log('IndividualResponsibilities.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('IndividualResponsibilities.js/onSubmit');
        fetch('/api/reports/IndividualResponsibilities', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'employeeId', type: 'int', value: !isNaN(this.state.selectedEmployee) ? parseInt(this.state.selectedEmployee) : 0 }
            ]
            )
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        employeeData: results.data[0] != null && results.data[0].employees != null ? JSON.parse(results.data[0].employees) : [],
                        clientData: results.data[0] != null && results.data[0].clients != null ? JSON.parse(results.data[0].clients) : []
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChange = (e) => {
        this.props.log('IndividualResponsibilities.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.props.changeSelector(e);
        this.setState({
            selector: e.target.value,
            selectedEmployee: parseInt(e.target.value)
        }, () => this.onSubmit());
    }

    getCSVdata = () => {
        this.props.log('IndividualResponsibilities.js/getCSVdata');
        let retArr = [];
        if (this.state.clientData.length > 0) {
            retArr = [[this.state.employeeData.filter(employee => employee.employeeId === parseInt(this.state.selectedEmployee)).map(employee => employee.lastName + ', ' + employee.firstName)[0], ''], [], ['Client', 'Tasks']];
            this.state.clientData.forEach(client => {
                const maxTasks = client.tasks != null ? (client.tasks.length) : 0;
                const maxLength = Math.max(1, maxTasks) + 1;
                let clientArr = [...Array(maxLength)].map(row => ['', '', '']);
                clientArr[0] = [client.name + (parseInt(client.primary) === 1 ? ' (Account Owner)' : (parseInt(client.processor) === 1 ? ' (Processor)' : ' (Backup)')), ''];

                let counter = 0;
                if (client.tasks != null) {
                    client.tasks.forEach((task, taskIndex) => {
                        if (clientArr[counter] != null) clientArr[counter][1] = task.name;
                        counter += 1;
                    });
                } else {
                    counter += 1;
                }
                retArr = retArr.concat(clientArr);
            })
        }
        this.props.passData(retArr, "individual-responsibilities_" + this.state.employeeData.filter(employee => employee.employeeId === parseInt(this.state.selectedEmployee)).map(employee => employee.firstName + '-' + employee.lastName)[0]);
    }

    render() {
        this.props.info('IndividualResponsibilities.js/render');
        return (
            <><Row className="mt-4">
                <Col md={4}>
                    <Input type="select"
                        name="selector"
                        onChange={(e) => this.onChange(e)}
                        value={this.props.isFieldNull(this.state.selector)}
                    >
                        <option value="0">SELECT EMPLOYEE</option>
                        {
                            this.state.employeeData.map(employee => (
                                <option
                                    key={"individualResponsibilities_employee_" + employee.employeeId}
                                    value={this.props.isFieldNull(employee.employeeId)}
                                >{employee.lastName + ', ' + employee.firstName}</option>
                            ))
                        }
                    </Input>
                </Col>
            </Row>
                {(this.state.selectedEmployee === 0) ? <></> :
                    <>
                        <Row className="my-3">
                            <Col md={12}><h2>Clients and Tasks</h2></Col>
                        </Row>
                        {(this.state.clientData.length > 0) ?
                            <Row>
                                <Col md={4}>
                                    <h3>Account Owner</h3>
                                    <ul>
                                        {this.state.clientData.filter(client => parseInt(client.primary) === 1).map((client, clientIndex) => (
                                            <li key={clientIndex}>{client.name}
                                                {client.tasks != null ? <ul>{client.tasks.map(task => (
                                                    <li>{task.name}</li>
                                                ))}</ul> : <></>}
                                            </li>
                                        ))}</ul>
                                </Col>
                                <Col md={4}>
                                    <h3>Processor</h3>
                                    <ul>
                                        {this.state.clientData.filter(client => parseInt(client.processor) === 1).map((client, clientIndex) => (
                                            <li key={clientIndex}>{client.name}
                                                {client.tasks != null ? <ul>{client.tasks.map(task => (
                                                    <li>{task.name}</li>
                                                ))}</ul> : <></>}
                                            </li>
                                        ))}</ul>
                                </Col>
                                <Col md={4}>
                                    <h3>Backup</h3>
                                    <ul>
                                        {this.state.clientData.filter(client => parseInt(client.secondary) === 1).map((client, clientIndex) => (
                                            <li key={clientIndex}>{client.name}
                                                {client.tasks != null ? <ul>{client.tasks.map(task => (
                                                    <li>{task.name}</li>
                                                ))}</ul> : <></>}
                                            </li>
                                        ))}</ul>
                                </Col>
                            </Row> : <>No Results</>}</>
                }
            </>
        );

    }
}

export default IndividualResponsibilities;
